/** Actor row for grouped notification avatars (API shape). */
export interface NotificationActor {
  id: string
  name?: string
  avatarUrl?: string | null
}

/** Parsed `content.data` from the notifications API. */
export interface NotificationContentData {
  followerId?: string
  followerUsername?: string
  actorId?: string
  actorUsername?: string
  actorAvatarUrl?: string
  actorIds?: string[]
  actors?: NotificationActor[]
  actorCount?: number
  postId?: string
  postTitle?: string
  postName?: string
  action?: 'follow' | 'like' | 'save' | 'comment' | 'remix'
  actionIcon?: 'heart' | 'bookmark' | 'comment' | 'remix'
  isCollapsed?: boolean
  collapsedCount?: number
  involvedUserIds?: string[]
  originalNotificationIds?: string[]
  [key: string]: unknown
}

export default class Notification {
  _id: string
  user_id: string
  type: string
  status: string
  priority: number
  timestamps: {
    created: Date | string
    scheduled?: string
    sent?: string
    read?: string
  }
  content: {
    title?: string
    body?: string
    deepLink?: string
    imageUrl?: string
    data: NotificationContentData
  }
  processed: boolean
  ttl?: unknown

  constructor(data: Record<string, unknown>) {
    this._id = data._id as string
    this.user_id = data.user_id as string
    this.type = data.type as string
    this.status = (data.status as string) || 'pending'
    this.priority = (data.priority as number) || 3
    const timestamps = data.timestamps as Record<string, unknown> | undefined
    this.timestamps = {
      created: (timestamps?.created as Date | string) || new Date(),
      scheduled: timestamps?.scheduled as string | undefined,
      sent: timestamps?.sent as string | undefined,
      read: timestamps?.read as string | undefined,
    }
    const content = data.content as Record<string, unknown> | undefined
    this.content = {
      title: content?.title as string | undefined,
      body: content?.body as string | undefined,
      deepLink: content?.deepLink as string | undefined,
      imageUrl: content?.imageUrl as string | undefined,
      data: (content?.data as NotificationContentData) || {}
    }
    this.processed = (data.processed as boolean) || false
    this.ttl = data.ttl
  }
}
